import { render, staticRenderFns } from "./NewItemComponent.vue?vue&type=template&id=34f324c6&scoped=true&"
import script from "./NewItemComponent.vue?vue&type=script&lang=js&"
export * from "./NewItemComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f324c6",
  null
  
)

export default component.exports